import { NotificationService } from "../../services/notifications/NotificationService";
import { Email } from "models";
import { useState } from "react";

export function useNotifications() {
  const [isMailLoading, setMailLoading] = useState(false);

  const sendEmail = (
    email: Email,
    emailSuccessCallback?: () => void,
    errorCallback?: () => void
  ): void => {
    const handleError = () => {
      if (errorCallback) {
        errorCallback();
      }
    };

    const handleSuccess = () => {
      if (emailSuccessCallback) {
        emailSuccessCallback();
      }
    };

    NotificationService.handleSendEmail(email, handleSuccess, handleError);
  };

  return { sendEmail, isMailLoading };
}
